/**
 * ProductDialog Component
 */
(function () {

    'use strict';

    /**
     * Render ProductDialog
     * @name productDialogCtrl
     * @type ItxProductDialogCmpCtrl
     */
    var ItxProductDialogCmp = {
        bindings: {            
            product: '<',
            selectedColorIndex: '<',
            closeDialog: '&',
            notEditable: '<',
            position: '<',
            ignoreColorStock: '<',
            showBack:'<'
        },
        controller: ItxProductDialogCmpCtrl,
        controllerAs: 'productDialogCtrl',
        templateUrl: 'ItxProductDialog.html'
    };

    ItxProductDialogCmpCtrl.$inject = ['imPopupService','Product'];

    function ItxProductDialogCmpCtrl(imPopupService,Product) {
        var _this = this; 
        if(!_this.product.state){
            _this.product = new Product(_this.product).fetch().then(() => {
                imPopupService.sendPopupEcommerce(_this.product, _this.product.state.selectedColorIndex, _this.position);
            });
        } else {
            imPopupService.sendPopupEcommerce(_this.product, _this.product.state.selectedColorIndex, _this.position);
        }
    }

   

    /** Public */
    angular.module('itxApp.common')
        .component('itxProductDialog', ItxProductDialogCmp);

})(window.itxApp);
